import { mutatorAction } from 'satcheljs';
import { store } from '../store/store';

export default mutatorAction('SET_USE_SYSTEM_DARK_MODE', (useSystemDarkModeSettings: boolean) => {
    store.useSystemDarkModeSettings = useSystemDarkModeSettings;
});
